import * as React from 'react';

function SvgLaybuyColourBorder(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 45 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.498 12.296c0-.08.063-.146.14-.146.076 0 .139.066.139.146v3.529h2.093c.07 0 .128.06.128.134a.131.131 0 01-.128.134h-2.232a.145.145 0 01-.14-.145v-3.652zM22.615 14.73l-.988-2.267-.988 2.266h1.976zm-2.773 1.169l1.6-3.623a.197.197 0 01.188-.14h.01c.085 0 .161.056.188.14l1.595 3.615a.2.2 0 01.022.086.135.135 0 01-.134.134.166.166 0 01-.14-.111l-.438-1.008h-2.21l-.44 1.014a.143.143 0 01-.133.105.128.128 0 01-.128-.123c0-.03.007-.061.02-.09zM25.206 14.54l-1.462-2.152a.19.19 0 01-.027-.086.15.15 0 01.145-.146.149.149 0 01.129.086l1.359 2.043 1.365-2.043a.152.152 0 01.123-.086.148.148 0 01.14.14.22.22 0 01-.043.113l-1.45 2.125v1.432c0 .08-.063.146-.14.146a.142.142 0 01-.14-.146V14.54zM29.761 15.334c.364 0 .583-.134.583-.425v-.011c0-.263-.188-.425-.61-.425h-.954v.86l.981.001zm-.22-1.577c.364 0 .595-.124.595-.415v-.01c0-.259-.193-.404-.541-.404h-.814v.829h.76zm-1.564-1.153c0-.238.184-.43.412-.43h1.327c.428 0 .766.123.98.344a.92.92 0 01.257.666v.011c0 .443-.225.689-.494.845.433.173.701.437.701.963v.011c0 .716-.556 1.074-1.4 1.074h-1.37a.421.421 0 01-.412-.43v-3.054zM32.05 14.41v-1.84c0-.237.185-.43.412-.43.227 0 .412.193.412.43v1.82c0 .637.305.967.808.967.503 0 .809-.319.809-.94V12.57c0-.237.184-.43.411-.43.228 0 .412.193.412.43v1.813c0 1.186-.637 1.768-1.647 1.768s-1.617-.588-1.617-1.74zM37.401 14.579l-1.206-1.718a.526.526 0 01-.102-.308.411.411 0 01.41-.414h.002c.187 0 .305.106.407.264l.91 1.37.926-1.382c.102-.156.224-.258.396-.258a.389.389 0 01.401.42.55.55 0 01-.107.302l-1.209 1.707v1.13c0 .238-.184.43-.412.43a.421.421 0 01-.411-.43l-.005-1.114z"
        fill="currentColor"
      />
      <mask
        id="LaybuyColourBorder_svg__a"
        maskUnits="userSpaceOnUse"
        x={4}
        y={9}
        width={11}
        height={9}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.678 9.291h9.596v8.13H4.678v-8.13z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#LaybuyColourBorder_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.33 10.021l-.866.905c-.06.063-.146 0-.146 0l-1.107-1.18a.89.89 0 00-1.294 0 .99.99 0 000 1.354l1.834 1.922a.89.89 0 001.295 0l1.538-1.608.27-.289a.458.458 0 01.668 0 .491.491 0 01-.004.684l-.277.292-2.793 2.922a.112.112 0 01-.163.006l-.005-.006-3.04-3.178a.89.89 0 00-1.295 0 .991.991 0 000 1.354l3.79 3.962-.02-.018a.89.89 0 001.295 0l3.528-3.69.037-.038c.911-.922.934-2.441.053-3.393a2.226 2.226 0 00-3.298 0z"
          fill="#786DFF"
        />
      </g>
      <rect x={0.5} y={0.5} width={44} height={26} rx={1.5} stroke="#E1E3E5" />
    </svg>
  );
}

export default SvgLaybuyColourBorder;
